import classes from '~/config/classes'
import { values as breakpoint } from '~/config/breakpoints'

/**
 * Adds event listeners to quick add buttons on mobile
 * - this is a UX enhancement to allow users to see the quick add options on
 *  mobile without accidently adding to cart on touchstart.
 * - button reveals options on touchstart but keeps pointer events none
 * until touchend
 */
export const throttleTapMobile = (elements, width = breakpoint.m) => {

  if (window.innerWidth < width) {
    elements.forEach((element) => {
      const button = element.querySelector('.js-quickAddBtnVariants')
      button.addEventListener('touchend', () => {
        setTimeout(() => {
          if (!element.classList.contains(classes.active)) {
            element.classList.add(classes.active)
          }
        }, 300)
      })
    })

    document.addEventListener('click', () => {
      elements.forEach((button) => {
        button.classList.remove(classes.active)
      })
    })
  }
}
